"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useState } from "react";
import { cx } from "@/utils/cx";
import { formatNetworkLabel, getNetworkIconPath, getNetworkTokenFallbackSymbol } from "../utils/networkIcons";
import { TokenIconOnly } from "./TokenIcon";
const sizeMap = {
  sm: {
    px: 20,
    className: "size-5"
  },
  md: {
    px: 24,
    className: "size-6"
  },
  lg: {
    px: 32,
    className: "size-8"
  }
};
interface NetworkIconProps {
  network: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}
export function NetworkIcon(t0) {
  const $ = _c(19);
  const {
    network,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const [imgError, setImgError] = useState(false);
  const {
    px,
    className: sizeClass
  } = sizeMap[size];
  let t2;
  if ($[0] !== network) {
    t2 = getNetworkIconPath(network);
    $[0] = network;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const iconPath = t2;
  if (iconPath && !imgError) {
    let t3;
    if ($[2] !== network) {
      t3 = formatNetworkLabel(network);
      $[2] = network;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    const t4 = `${t3} network`;
    let t5;
    if ($[4] !== className || $[5] !== sizeClass) {
      t5 = cx("shrink-0 object-contain", sizeClass, className);
      $[4] = className;
      $[5] = sizeClass;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = () => setImgError(true);
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    let t7;
    if ($[8] !== iconPath || $[9] !== px || $[10] !== t4 || $[11] !== t5) {
      t7 = <Image src={iconPath} alt={t4} width={px} height={px} className={t5} onError={t6} />;
      $[8] = iconPath;
      $[9] = px;
      $[10] = t4;
      $[11] = t5;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t3;
  if ($[13] !== network) {
    t3 = getNetworkTokenFallbackSymbol(network);
    $[13] = network;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== className || $[16] !== size || $[17] !== t3) {
    t4 = <TokenIconOnly symbol={t3} size={size} className={className} />;
    $[15] = className;
    $[16] = size;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}
interface NetworkIconLabelProps extends NetworkIconProps {
  showLabel?: boolean;
  labelClassName?: string;
}
export function NetworkIconLabel(t0) {
  const $ = _c(14);
  const {
    network,
    size: t1,
    className,
    showLabel: t2,
    labelClassName
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const showLabel = t2 === undefined ? true : t2;
  const textSize = size === "sm" ? "text-xs font-medium" : "text-sm font-medium";
  let t3;
  if ($[0] !== className) {
    t3 = cx("inline-flex items-center gap-1.5 text-text-secondary", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== network || $[3] !== size) {
    t4 = <NetworkIcon network={network} size={size} />;
    $[2] = network;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== labelClassName || $[6] !== network || $[7] !== showLabel || $[8] !== textSize) {
    t5 = showLabel ? <span className={cx(textSize, labelClassName)}>{formatNetworkLabel(network)}</span> : null;
    $[5] = labelClassName;
    $[6] = network;
    $[7] = showLabel;
    $[8] = textSize;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <span className={t3}>{t4}{t5}</span>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}